/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams } from "react-router";
import FormGenerationContract from "./formGenerationContract";
import InfoMainContract from "./infoMainContract";
import { REQUIRED_MESSAGE } from "../../constants";
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import {
  getContractPerson,
  getContractTypeForGenerate,
  getMaestras,
} from "../../actions/generation-contarct-action";
import { getContractTypeFormatByContractType } from "../../actions/contract-type-actions";
import { DataContext } from "../../context/reducers/contextSearchUser";
import { validatePreviousContract } from "../../actions/contract-actions";
import SeeVacancies from "./see-vacancies";
import { getPostulateByDocAndNumber } from "../../actions/postulates-actions";

const initialStateForm = {
  documentType: "",
  document: "",
  idContractTypeFormat: "",
  format: "",
};

const GenerationContracts = (props) => {
  const _ = require("lodash");
  const { idContract, idVacancie, document, numberDocument } = useParams();
  const [stateForm, setStateForm] = useState(initialStateForm);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [next, setNext] = useState(false);
  const [validateNumber, setValidateNumber] = useState(false);
  const [{}, dispatch] = useStateValue();
  const [dataMaestras, setDataMaestras] = useState([]);
  const [dataUser, setDataUser] = useState([]);
  const [documentUser, setDocumentUser] = useState({});
  const [contractType, setContractType] = useState([]);
  const { setIdVacancie, setContractSalary } = useContext(DataContext);
  const [formats, setFormats] = useState([]);
  const [idContractType, setIdContractType] = useState("");
  const [nameContractType, setNameContractType] = useState("");
  const [toChangeContractType, setToChangeContractType] = useState(false);
  const [selectedContract, setSelectedContract] = useState(false);
  const [hasVancies, setHasVancies] = useState(false);
  const [listVacancies, setListVacancies] = useState([]);
  const [valVacancy, setValVacancy] = useState({});

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    title: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const [paginatorRequest, setPaginatorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const handleChange = (e) => {
    setValue("format", "");
    setFormats([]);
    const { name, value } = e.target;
    setNameContractType(value);
    const getId = contractType.filter((x) => x.contractTypes === value);
    const contractTypeId = getId.map((x) => x.id).toString();
    setIdContractType(contractTypeId);
    setToChangeContractType(true);
    setStateForm({
      ...stateForm,
      [name]: value,
    });
    if (idContract) {
      if (
        value === "CONTRATO_DE_APRENDIZAJE" ||
        value === "CONTRATO_POR_OBRA_LABOR" ||
        value === "CONTRATO_TERMINO_INDEFINIDO_PRIMERA_VEZ"
      ) {
        setSelectedContract(true);
        setMessage({
          description:
            "Señor usuario para este tipo de contrato, no aplican las renovaciones, verifique por favor ",
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
      } else {
        setSelectedContract(false);
      }
    }
  };

  useEffect(() => {
    if (toChangeContractType) {
      const getFormat = async () => {
        const response = await getContractTypeFormatByContractType(
          idContractType,
          dispatch
        );
        const orderList = response?.data?.sort((a, b) => {
          return a?.name.localeCompare(b?.name);
        });
        setFormats(orderList);
        setToChangeContractType(false);
      };
      getFormat();
    }
  }, [idContractType, toChangeContractType, dispatch]);

  const schema = yup.object().shape({
    documentType: yup.string().required(REQUIRED_MESSAGE),
    document: validateNumber
      ? yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
          )
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
          ),
    idContractTypeFormat: yup.string().required(REQUIRED_MESSAGE),
    format: yup.string().required(REQUIRED_MESSAGE),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    setIdVacancie(idVacancie);
    if (document && numberDocument) {
      setValue("documentType", document);
      setValue("document", numberDocument);
    }
  }, [document, idVacancie, numberDocument, setIdVacancie, setValue]);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const seePostulateVacancies = () => {
    setHasVancies(false);
    setMessage({
      description:
        "Este usuario se encuentra aplicando a más de una vacante.\nPor favor seleccionar a la que desea generar contrato.",
      textButtonSubmit: "VACANTES",
      handleClick: () => handleClickDetailVacancies(),
      handleClickOut: () => handleClickCancel(),
      type: "WARNING",
      open: true,
    });
  };

  const handleClickDetailVacancies = () => {
    handleClickClose();
    setHasVancies(true);
  };

  const handleClickCancel = () => {
    setMessage({ ...message, open: false });
    props.history.push("/dashboard/contracts");
  };

  const handleChangeCheckedVacancy = (e, info) => {
    setValVacancy(info);
    setHasVancies(false);
    const objDocument = {
      documentType: info?.person.documentType,
      document: info?.person.documentNumber,
    };
    handleClickContinue("", objDocument);
  };

  const handleClickContinue = async (data, info) => {
    const response = await validatePreviousContract(
      info?.documentType,
      info?.document,
      dispatch
    );
    if (response && response?.status >= 200 && response?.status <= 399) {
      if (!response.data) {
        setMessage({ ...message, open: false });
        setDataUser(data);
        setTimeout(() => {
          setInputDisabled(true);
          setNext(true);
        }, 100);
      } else {
        setMessage({
          description:
            "No es posible generar un nuevo contrato para este usuario, ya cuenta con uno activo.",
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
        return;
      }
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setInputDisabled(false);
      setNext(false);
      setMessage({
        description: response?.data.detail,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else if (!response?.data) {
      setTimeout(() => {
        setInputDisabled(true);
        setNext(true);
      }, 100);
    }
  };

  const responseSuccess = (response, info, postulateToVacancy) => {
    if (selectedContract) {
      setMessage({
        description:
          "Señor usuario para este tipo de contrato, no aplican las renovaciones, verifique por favor",
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
      return;
    } else {
      if (idContract) {
        setMessage({
          description: "¿Esta seguro de renovar contrato?",
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickContinue(response, info),
          handleClickOut: () => handleClickCancel(),
          type: "QUESTION",
          open: true,
        });
      } else {
        if (postulateToVacancy?.content?.length > 0) {
          seePostulateVacancies();
          setListVacancies(postulateToVacancy?.content);
        } else {
          handleClickContinue(response, info);
        }
      }
    }
  };

  const onSubmit = async (info) => {
    setDocumentUser(info);
    const response = await getContractPerson(
      info?.document,
      info?.documentType
    );
    if (response && response?.status >= 200 && response?.status <= 399) {
      const bodyPostulate = {
        documentType: info?.documentType,
        documentNumber: info?.document,
        status: "SELECTED",
      };
      const resp = await getPostulateByDocAndNumber(
        paginatorRequest,
        bodyPostulate
      );
      const postulateToVacancy = resp?.data?.pagedPostulateResponse;
      responseSuccess(response, info, postulateToVacancy);
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setInputDisabled(false);
      setNext(false);
      setMessage({
        description: response?.data.detail,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else if (!response?.data) {
      setTimeout(() => {
        setInputDisabled(true);
        setNext(true);
      }, 100);
    } else {
      setInputDisabled(false);
      setNext(false);
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  useEffect(() => {
    const getDataMaestras = async () => {
      const resp = await getMaestras();
      setDataMaestras(resp?.data);
    };

    const getContractTypess = async () => {
      const resp = await getContractTypeForGenerate();
      let orderContractTypes = _.sortBy(
        resp && resp.data,
        (o) => o.contractTypeDescription
      );
      setContractType(orderContractTypes);
    };
    getContractTypess();

    getDataMaestras();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Contratos  |  Generar contrato",
      breadCrumbSubText: "Generar contrato",
      index: 3,
    });
  }, []);

  const validateTypeDocumentPastport = watch("documentType") === "PP";
  const validateTypeDocumentForeigner = watch("documentType") === "CE";
  const validateTypeContract =
    watch("idContractTypeFormat") === "CONTRATO_PRESTACION_DE_SERVICIO";

  useEffect(() => {
    if (validateTypeDocumentPastport || validateTypeDocumentForeigner) {
      setValidateNumber(true);
    } else {
      setValidateNumber(false);
    }
    if (validateTypeContract) {
      setContractSalary(true);
    } else {
      setContractSalary(false);
    }
  }, [
    validateTypeDocumentPastport,
    validateTypeDocumentForeigner,
    dispatch,
    validateTypeContract,
    setContractSalary,
  ]);

  return (
    <div>
      <FormGenerationContract
        handleChange={handleChange}
        onSubmit={onSubmit}
        initialStateForm={initialStateForm}
        next={next}
        inputDisabled={inputDisabled}
        setValue={setValue}
        register={register}
        control={control}
        handleSubmit={handleSubmit}
        errors={errors}
        getValues={getValues}
        dataMaestras={dataMaestras}
        contractType={contractType}
        formats={formats}
      />

      {hasVancies &&
        listVacancies?.map((vacancie) => (
          <SeeVacancies
            data={vacancie}
            valVacancy={valVacancy}
            handleChangeCheckedVacancy={handleChangeCheckedVacancy}
          />
        ))}

      {next && (
        <InfoMainContract
          inputDisabled={inputDisabled}
          dataUser={dataUser}
          documentUser={documentUser}
          dataMaestras={dataMaestras}
          idContractType={nameContractType}
          idContract={idContract}
          valVacancy={valVacancy}
        />
      )}

      {/* {hasVancies &&(
                   <TablePagination
                        style={{ display: "flex", justifyContent: "center" }}
                        rowsPerPageOptions={[5, 10, 15]}
                        count={paginadorResponse.totalRows}
                        rowsPerPage={setPaginatorRequest.size}
                        page={setPaginatorRequest.page}
                        labelRowsPerPage="Registros por página"
                        onChangePage={changePage}
                        onChangeRowsPerPage={changeAmountOfRecords}
                    />
                )
            } */}

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        title={message.title}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default GenerationContracts;
